import { createGlobalStyle } from "styled-components";

const Colors = createGlobalStyle`
  .Color_primary {
    color: ${({ theme }) => theme.colors.fog["80"]};
  }

  .Color_onPrimary {
    color: ${({ theme }) => theme.colors.fog["00"]};
  }

  .Color_secondary {
    color: ${({ theme }) => theme.colors.fog["60"]};
  }

  .Color_tertiary {
    color: ${({ theme }) => theme.colors.fog["50"]};
  }

  .Color_coral80 {
    color: ${({ theme }) => theme.colors.coral["80"]};
  }

  .Color_coral40 {
    color: ${({ theme }) => theme.colors.coral["40"]};
  }

  .Color_coral30 {
    color: ${({ theme }) => theme.colors.coral["30"]};
  }

  .Color_coral5 {
    color: ${({ theme }) => theme.colors.coral["05"]};
  }

  .Color_dusk80 {
    color: ${({ theme }) => theme.colors.dusk["80"]};
  }
  
  .Color_dusk70 {
    color: ${({ theme }) => theme.colors.dusk["70"]};
  }

  .Color_dusk50 {
    color: ${({ theme }) => theme.colors.dusk["50"]};
  }

  .Color_dusk30 {
    color: ${({ theme }) => theme.colors.dusk["30"]};
  }

  .Color_dusk10 {
    color: ${({ theme }) => theme.colors.dusk["10"]};
  }

  .Color_eucalyptus80 {
    color: ${({ theme }) => theme.colors.eucalyptus["80"]};
  }

  .Color_eucalyptus50 {
    color: ${({ theme }) => theme.colors.eucalyptus["50"]};
  }

  .Color_eucalyptus30 {
    color: ${({ theme }) => theme.colors.eucalyptus["30"]};
  }

  .Color_eucalyptus20 {
    color: ${({ theme }) => theme.colors.eucalyptus["20"]};
  }

  .Color_eucalyptus5 {
    color: ${({ theme }) => theme.colors.eucalyptus["05"]};
  }

  .Color_fog40 {
    color: ${({ theme }) => theme.colors.fog["40"]};
  }
  .Color_fog80 {
    color: ${({ theme }) => theme.colors.fog["80"]};
  }

  .Color_fog30 {
    color: ${({ theme }) => theme.colors.fog["30"]};
  }

  .Color_dawn50 {
    color: ${({ theme }) => theme.colors.dawn["50"]};
  }

  .Color_dawn40 {
    color: ${({ theme }) => theme.colors.dawn["40"]};
  }

  .Color_dawn70 {
    color: ${({ theme }) => theme.colors.dawn["70"]};
  }

  .Color_subdued {
    color: ${({ theme }) => theme.colors.subdued};
  }

  .Color_red {
    color: ${({ theme }) => theme.colors.red};
  }

  .Color_green {
    color: ${({ theme }) => theme.colors.green};
  }
`;

export { Colors };
